import { BrainCircuit, Files } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { FdeCopy } from '@/frontend/features/Fde/types'

interface Props {
  value: 'files' | 'knowledge'
  copy: FdeCopy
  onChange: (value: 'files' | 'knowledge') => void
}

export default function WorkspaceModeTabs({ value, copy, onChange }: Props) {
  return (
    <div className="flex h-8 items-center rounded-lg bg-muted p-0.5" role="tablist" aria-label={copy.material.workspace_views}>
      <ModeButton active={value === 'files'} label={copy.material.files} icon={Files} onClick={() => onChange('files')} />
      <ModeButton active={value === 'knowledge'} label={copy.material.knowledge} icon={BrainCircuit} onClick={() => onChange('knowledge')} />
    </div>
  )
}

function ModeButton({ active, label, icon: Icon, onClick }: { active: boolean; label: string; icon: typeof Files; onClick: () => void }) {
  return (
    <button type="button" role="tab" aria-selected={active} onClick={onClick} className={cn('flex h-7 items-center gap-1.5 rounded-md px-2.5 text-xs font-medium transition-colors', active ? 'bg-background text-foreground shadow-xs' : 'text-muted-foreground hover:text-foreground')}>
      <Icon className="size-3.5" />
      {label}
    </button>
  )
}
